import CommonPage from "../components/page/CommonPage";
import TerminalDetail from "../components/terminal/TerminalDetail";
import { PageTitle } from "../components/common/PageTitle";
import { FC } from "react";

const TerminalDetailPage : FC= () => {
  return (
    <CommonPage selectBtnIndex={2} >
      <PageTitle title="端末詳細" />
      <TerminalDetail />
    </CommonPage>
  );
};

export default TerminalDetailPage;
